var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content mrs-page" },
    [
      _c(
        "div",
        { staticClass: "mrs-table-card row-data" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "mrs-tabs",
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTargetTypeChange },
              model: {
                value: _vm.targetType,
                callback: function ($$v) {
                  _vm.targetType = $$v
                },
                expression: "targetType",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Lớp học", name: "CLASS" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-school" }),
                    _vm._v(" Lớp học\n        "),
                  ]),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Nhóm học sinh", name: "GROUP" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                    _vm._v(" Nhóm học sinh\n        "),
                  ]),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Gói dịch vụ", name: "PACKAGE" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("i", { staticClass: "el-icon-goods" }),
                    _vm._v(" Gói dịch vụ\n        "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mrs-table-wrapper" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  staticClass: "sk-table",
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": _vm.$tableMaxHeightSmall,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "STT",
                      type: "index",
                      width: "55",
                      align: "center",
                      index: _vm.indexMethod,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.targetColumnLabel, "min-width": "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.targetName
                              ? _c("span", { staticClass: "mrs-target-name" }, [
                                  _vm._v(_vm._s(row.targetName)),
                                ])
                              : _c("span", { staticClass: "mrs-text-muted" }, [
                                  _vm._v(
                                    "— (ID: " + _vm._s(row.targetId) + ")"
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.targetType === "CLASS"
                    ? _c("el-table-column", {
                        attrs: { label: "Khối", "min-width": "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.gradeName
                                    ? _c("span", [
                                        _vm._v(_vm._s(row.gradeName)),
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "mrs-text-muted" },
                                        [_vm._v("—")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2629593369
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { label: "Loại", width: "140", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.targetTypeTagType(row.targetType),
                                  size: "mini",
                                  effect: "light",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.targetTypeTagLabel(row.targetType)
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số khoản đăng ký",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "mrs-revenue-count" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.numberOfRegisteredRevenues) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tác vụ",
                      width: "160",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                  size: "mini",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetailDialog(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Thêm khoản thu\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mrs-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.page,
                  "page-sizes": [25, 50, 100],
                  "page-size": _vm.pagination.size,
                  total: _vm.pagination.total,
                  layout: "sizes, prev, pager, next",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.pagination, "size", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.pagination, "size", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("revenue-scope-detail-dialog", {
        ref: "detailDialog",
        on: { saved: _vm.fetchData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }